let panelEl;
let triggerEl;
let isOpen = false;

function init() {

	panelEl = document.querySelector('.offcanvas-panel');
	triggerEl = document.querySelector('.top-bar__nav-mobile-trigger');

	if (!panelEl) {
		return;
	}

	triggerEl.addEventListener('click', (event) => {
		toggle();
	}, false);

}

function show() {
	panelEl.classList.add('is--open');
	triggerEl.classList.add('is--open');
	document.body.classList.add('u--body-lock');
	isOpen = true;
}

function close() {
	panelEl.classList.remove('is--open');
	triggerEl.classList.remove('is--open');
	document.body.classList.remove('u--body-lock');
	isOpen = false;
}

function toggle() {
	if (isOpen) {
		close();
	} else {
		show();
	}
}

export default {
	init,
	show,
	close,
	toggle
};
